import React from 'react'
import '../style.css'

const AboutUs = () => {
    return (
        <div className='aboutus-section'>
            <div className='aboutus-img-div'>
                <img className='aboutus-img' src="/img/about.png" alt="" />
            </div>

            <div className='aboutus-content'>
                <h1 className='aboutus-h1'>About Supramax</h1>
                <h1 className='aboutus-mini-h1'>We work for you since 2018</h1>
                <p className='aboutus-para'>Supramax Global is a leading provider of high-performance structured cabling solutions. We specialize in a comprehensive range of products including data cables, patch cords and panels, fiber products, and rack solutions—designed to meet the evolving needs of modern network infrastructure.

With a focus on quality, durability, and innovation, we serve industries across telecom, IT, and data centers, providing copper and fiber connectivity solutions that ensure reliable communication and data transfer. Our commitment to excellence, customer satisfaction, and technological advancement sets us apart as a trusted name in the global cabling market.

</p>
                {/* <button className='solid-button'>View All</button> */}
            </div>

        </div>
    )
}

export default AboutUs
